import React from 'react';
import { AlertTriangle, CheckCircle2, Clock } from 'lucide-react';
import type { Clase } from '../../types';
import { estadoTiempo } from '../../utils/reglas';
export function PanelTiempo({
  clase
}: {
  clase: Clase;
}) {
  const t = estadoTiempo(clase);
  const estilos = {
    ok: 'border-verde/40 bg-verde/5 text-tinta',
    atencion: 'border-oro-oscuro/50 bg-oro/10 text-tinta',
    excedido: 'border-alerta/50 bg-alerta/5 text-tinta'
  }[t.estado];
  const Icono = t.estado === 'ok' ? CheckCircle2 : AlertTriangle;
  const colorIcono = t.estado === 'ok' ? 'text-verde' : t.estado === 'atencion' ? 'text-oro-oscuro' : 'text-alerta';
  return <div className={`flex flex-wrap items-center justify-between gap-3 rounded-xl border p-3 ${estilos}`} role="status" aria-live="polite" data-id="element-60" data-mp="11f3nqhrc9vw1">
      <div className="flex items-center gap-2" data-id="element-61" data-mp="1bdau66o04vjs">
        <Clock className="h-4 w-4 text-tinta-sec" aria-hidden="true" data-id="element-62" data-mp="1baewmjg2g8vv" />
        <span className="text-sm font-bold text-tinta-titulo" data-id="element-63" data-mp="1gc463unn4ehu">
          Planificado: {t.planificado} de {t.objetivo} min
        </span>
      </div>
      <div className="flex items-center gap-2" data-id="element-64" data-mp="iolpokz3fbdr">
        <Icono className={`h-4 w-4 ${colorIcono}`} aria-hidden="true" data-id="element-65" data-mp="imr37286bb7k" />
        <span className="text-sm font-semibold" data-id="element-66" data-mp="doh8esqd2cmh">{t.texto}</span>
      </div>
    </div>;
}